
import { CrownOutlined } from '@ant-design/icons';
import {Button, message, Popover, Tag,Tooltip, Modal} from 'antd';
import { useEffect , useState} from 'react';
import ShowPlans from '../show_plans/main';


const CrownReturn = ({premiumUser, limit_reached}) =>{

    const[showPlanModal, setShowPlanModal] = useState(false);
    const[messageApi, contextHolder] = message.useMessage();
    const[paymentLinkLoading, setPaymentLinkLoading] = useState(false);
    const [paymentLinkData, setPaymentLinkData] = useState(null);
    // const setPaymentLinkData = (data) => {
    //     setPaymentLinkData(data);
    //     setPaymentLinkLoading(false);
    // }

    if(premiumUser) 
    return <CrownOutlined />

    return (
    
        <>
        <Popover content={<Button onClick={() => {setShowPlanModal(true)}}>See Plans</Button>} title={limit_reached == true ? "Limit Reached!! Upgrade your plan to increase limit" : "Upgrade your plan to access this feature"} style={{cursor:'pointer'}}><Tag icon={<CrownOutlined style={{fontSize:'16px'}} /> } color="purple" ></Tag></Popover>
       <Modal
          title="Plans"
          open={showPlanModal}
          onCancel={() => {setShowPlanModal(false); 
      
            }}
          footer={null}
          style={{ top: 0 }}
          width='100%'
          height={"100%"}
          // style={{ maxWidth: '1200px' }}
        >


          <ShowPlans messageApi={messageApi} setPaymentLinkLoading={setPaymentLinkLoading} setPaymentLinkData={setPaymentLinkData} currentPlan={localStorage.getItem("planid")} />
        </Modal>
       
        </>
    )
}

export default CrownReturn;